import _objectSpread from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import { MOST_NEGATIVE_SINGLE_FLOAT, MOST_POSITIVE_SINGLE_FLOAT } from '../constants';
var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'clamped-max',
  channelInterpretation: 'speakers',
  coneInnerAngle: 360,
  coneOuterAngle: 360,
  coneOuterGain: 0,
  distanceModel: 'inverse',
  maxDistance: 10000,
  orientationX: 1,
  orientationY: 0,
  orientationZ: 0,
  panningModel: 'equalpower',
  positionX: 0,
  positionY: 0,
  positionZ: 0,
  refDistance: 1,
  rolloffFactor: 1
};
export var createPannerNodeConstructor = function createPannerNodeConstructor(audioNodeConstructor, createAudioParam, createNativePannerNode, createPannerNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(PannerNode, _audioNodeConstructor);
    function PannerNode(context, options) {
      var _this;
      _classCallCheck(this, PannerNode);
      var nativeContext = getNativeContext(context);
      var mergedOptions = _objectSpread({}, DEFAULT_OPTIONS, options);
      var nativePannerNode = createNativePannerNode(nativeContext, mergedOptions);
      var isOffline = isNativeOfflineAudioContext(nativeContext);
      var pannerNodeRenderer = isOffline ? createPannerNodeRenderer() : null;
      _this = _possibleConstructorReturn(this, _getPrototypeOf(PannerNode).call(this, context, false, nativePannerNode, pannerNodeRenderer));
      _this._nativePannerNode = nativePannerNode;
      // Bug #74: Safari does not export the correct values for maxValue and minValue.
      _this._orientationX = createAudioParam(_assertThisInitialized(_assertThisInitialized(_this)), isOffline, nativePannerNode.orientationX, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
      _this._orientationY = createAudioParam(_assertThisInitialized(_assertThisInitialized(_this)), isOffline, nativePannerNode.orientationY, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
      _this._orientationZ = createAudioParam(_assertThisInitialized(_assertThisInitialized(_this)), isOffline, nativePannerNode.orientationZ, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
      _this._positionX = createAudioParam(_assertThisInitialized(_assertThisInitialized(_this)), isOffline, nativePannerNode.positionX, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
      _this._positionY = createAudioParam(_assertThisInitialized(_assertThisInitialized(_this)), isOffline, nativePannerNode.positionY, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
      _this._positionZ = createAudioParam(_assertThisInitialized(_assertThisInitialized(_this)), isOffline, nativePannerNode.positionZ, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
      // @todo Determine a meaningful tail-time instead of just using one second.
      setAudioNodeTailTime(_assertThisInitialized(_assertThisInitialized(_this)), 1);
      return _this;
    }
    _createClass(PannerNode, [{
      key: "coneInnerAngle",
      get: function get() {
        return this._nativePannerNode.coneInnerAngle;
      },
      set: function set(value) {
        this._nativePannerNode.coneInnerAngle = value;
      }
    }, {
      key: "coneOuterAngle",
      get: function get() {
        return this._nativePannerNode.coneOuterAngle;
      },
      set: function set(value) {
        this._nativePannerNode.coneOuterAngle = value;
      }
    }, {
      key: "coneOuterGain",
      get: function get() {
        return this._nativePannerNode.coneOuterGain;
      },
      set: function set(value) {
        this._nativePannerNode.coneOuterGain = value;
      }
    }, {
      key: "distanceModel",
      get: function get() {
        return this._nativePannerNode.distanceModel;
      },
      set: function set(value) {
        this._nativePannerNode.distanceModel = value;
      }
    }, {
      key: "maxDistance",
      get: function get() {
        return this._nativePannerNode.maxDistance;
      },
      set: function set(value) {
        this._nativePannerNode.maxDistance = value;
      }
    }, {
      key: "orientationX",
      get: function get() {
        return this._orientationX;
      }
    }, {
      key: "orientationY",
      get: function get() {
        return this._orientationY;
      }
    }, {
      key: "orientationZ",
      get: function get() {
        return this._orientationZ;
      }
    }, {
      key: "panningModel",
      get: function get() {
        return this._nativePannerNode.panningModel;
      },
      set: function set(value) {
        this._nativePannerNode.panningModel = value;
      }
    }, {
      key: "positionX",
      get: function get() {
        return this._positionX;
      }
    }, {
      key: "positionY",
      get: function get() {
        return this._positionY;
      }
    }, {
      key: "positionZ",
      get: function get() {
        return this._positionZ;
      }
    }, {
      key: "refDistance",
      get: function get() {
        return this._nativePannerNode.refDistance;
      },
      set: function set(value) {
        this._nativePannerNode.refDistance = value;
      }
    }, {
      key: "rolloffFactor",
      get: function get() {
        return this._nativePannerNode.rolloffFactor;
      },
      set: function set(value) {
        this._nativePannerNode.rolloffFactor = value;
      }
    }]);
    return PannerNode;
  }(audioNodeConstructor);
};